// import React, { Component } from 'react';
// import MainLayout from '../../components/layouts/main';
// import Constants from '../../data/constants';
// import GridButton from '../../components/GridButton';
// import Data from '../../data/data';
// import GridAddButton from '../../components/GridAddButton';
// import { motion } from 'framer-motion';
// import Animations from '../../animations/Animations';
// class BranchPage extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {};
//     }

//     componentDidMount() {
//         console.log("mounted brand")
//     }

//     render() {
//         const renderBrands = Data.BRANDS.map((brandObj) => {
//             return <GridButton title={brandObj.title} icon={brandObj.logo} data={brandObj}></GridButton>
//         })

//         return (
//             <MainLayout id={Constants.MENU_BRANCH}>
//                 <motion.div
//                     style={{ width: "100%", height: "100%" }}
//                     initial="initial"
//                     animate="animate"
//                     variants={Animations.STAGGER}>
//                     {[
//                         <GridAddButton></GridAddButton>,
//                         ...renderBrands]}
//                 </motion.div>
//             </MainLayout>
//         );
//     }
// }

// export default BranchPage;

import React, { Component } from "react";
import MainLayout from "../../components/layouts/main";
import Constants from "../../data/constants";
import GridButton from "../../components/GridButton";
import { motion } from "framer-motion";
import Animations from "../../animations/Animations";
import { Row, Col, message } from "antd";
import PopupManager from "../../managers/PopupManager";
import { connect } from "react-redux";
import {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectPage,
  selectBranch,
} from "../../actions";
import { useParams } from "react-router-dom";
import BranchTableView from "../../components/views/BranchTableView";
import PermissionManager from "../../managers/PermissionManager";
import PrimaryActionButton from "../../components/PrimaryActionButton";
import { MapPin } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const BranchPage = (props) => {
  const params = useParams();
  const { lang } = useProLanguage();
  const t = PRO_TRANSLATIONS[lang].branch;
  return (
    <BranchPageClass
      brandID={params.brandid}
      langT={t}
      {...props}
    ></BranchPageClass>
  );
};

class BranchPageClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      brandsData: [],
      branchesData: [],
      isMobile: window.innerWidth < 768,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    // console.log("mounted brand")

    const { selectedBrandData } = this.props;
    // console.log(JSON.stringify(selectedBrandData))

    if (selectedBrandData) {
      this.setState({ brandsData: selectedBrandData });
      this.updateBranchesTable();
    }

    this.onResize = () => {
      if (this._isMounted) {
        this.setState({ isMobile: window.innerWidth < 768 });
      }
    };
    window.addEventListener("resize", this.onResize);
  }

  componentWillUnmount() {
    this._isMounted = false;
    window.removeEventListener("resize", this.onResize);
  }

  componentWillReceiveProps(props) {
    if ("selectedBrandData" in props) {
      if (props.selectedBrandData) {
        this.setState({ brandsData: props.selectedBrandData });
        this.updateBranchesTable();
      }
    }
  }

  updateBranchesTable = () => {
    const { requestServerGet, userdata, selectedBrandData } = this.props;

    if (!selectedBrandData) return;

    requestServerGet(
      "get_branches",
      { brandid: selectedBrandData.BrandID },
      null,
      (branchResponse) => {
        const branches = branchResponse.data || [];
        // Fetch all screens for this brand to compute per-branch counts
        requestServerGet(
          "get_screens",
          { brandid: selectedBrandData.BrandID },
          null,
          (screenResponse) => {
            const screens = screenResponse.data || [];
            const countMap = {};
            screens.forEach((s) => {
              if (s.BranchID) {
                if (!countMap[s.BranchID])
                  countMap[s.BranchID] = { total: 0, online: 0, offline: 0 };
                countMap[s.BranchID].total++;
                if (s.IsOnline) countMap[s.BranchID].online++;
                else countMap[s.BranchID].offline++;
              }
            });
            if (this._isMounted) {
              const enrichedBranches = branches.map((b) => ({
                ...b,
                ScreenCount: countMap[b.BranchID]?.total || 0,
                OnlineCount: countMap[b.BranchID]?.online || 0,
                OfflineCount: countMap[b.BranchID]?.offline || 0,
              }));
              this.setState({ branchesData: enrichedBranches });

              // Auto-skip: if there's exactly 1 location, skip the selection
              // page and go straight to dashboard. This prevents confusion for
              // Lite→Pro users and is better UX in general.
              // Users can always navigate back via the location name in the
              // top bar or the "Locations" item in the sidebar.
              // if (branches.length === 1) {
              //   this.onBranchClicked(branches[0]);
              // }
            }
          },
          userdata.token,
        );
      },
      userdata.token,
    );
  };

  launchCreateBranch = () => {
    PopupManager.launchCreateBranchPopup();
  };

  onBranchClicked = (branchData) => {
    const { selectBranch, selectPage, selectedBrandData } = this.props;

    // Persist selected branch and brand to localStorage
    if (branchData && branchData.BranchID) {
      localStorage.setItem("active_branch_id", String(branchData.BranchID));
    }
    if (selectedBrandData && selectedBrandData.BrandID) {
      localStorage.setItem(
        "active_brand_id",
        String(selectedBrandData.BrandID),
      );
    }

    selectBranch(branchData);
    selectPage(Constants.SCREEN_PAGE);
  };

  launchCreateBranch = () => {
    PopupManager.launchCreateBranchPopup(this.updateBranchesTable);
  };

  render() {
    const createPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_BRANCH,
      PermissionManager.PERMISSION_TYPE_CREATE,
    );
    const editPermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_BRANCH,
      PermissionManager.PERMISSION_TYPE_EDIT,
    );
    const deletePermission = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_BRANCH,
      PermissionManager.PERMISSION_TYPE_DELETE,
    );

    const { selectPage, usertoken, requestServerPost, langT } = this.props;
    const { isMobile } = this.state;
    const t = langT || {
      title: "Locations",
      subtitle: "Select a location to view and manage its screens.",
      newBranch: "New Location",
    };

    return (
      <MainLayout
        {...this.props}
        id={Constants.BRANCH_PAGE}
        quietTitleBar={true}
        style={{ padding: 20 }}
        showSearchBar={true}
        showTopBarBrandLogo={true}
        showSideMenu={true}
        preventDefaultStepBack={true}
        onBackClicked={() => {
          selectPage(Constants.BRAND_PAGE);
        }}
      >
        <motion.div {...Animations.PAGE_ENTER}>
          {/* Page header */}
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "stretch" : "center",
              justifyContent: "space-between",
              background: "#fff",
              borderRadius: 16,
              padding: "20px 24px",
              border: "1px solid #e8ecf3",
              marginBottom: 20,
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 16,
                width: isMobile ? "100%" : undefined,
              }}
            >
              <div
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: 14,
                  flexShrink: 0,
                  background: "linear-gradient(135deg, #eef2ff, #e0e7ff)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <MapPin size={26} color="#6366f1" />
              </div>
              <div style={{ width: isMobile ? "100%" : undefined }}>
                <div
                  style={{
                    fontSize: 22,
                    fontWeight: 800,
                    color: "#0f172a",
                    lineHeight: 1.2,
                  }}
                >
                  {t.title}
                </div>
                <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 3 }}>
                  {t.subtitle}
                </div>
              </div>
            </div>
            {createPermission && (
              <PrimaryActionButton
                onClick={this.launchCreateBranch}
                style={
                  isMobile
                    ? { width: "100%", marginTop: 16, justifyContent: "center" }
                    : {}
                }
              >
                {t.newBranch}
              </PrimaryActionButton>
            )}
          </div>

          <BranchTableView
            data={this.state.branchesData}
            onRowClicked={this.onBranchClicked}
            onDelete={
              deletePermission
                ? (branchData) => {
                    const bData = branchData;
                    requestServerPost(
                      "delete_branch",
                      { branchid: bData.BranchID },
                      {},
                      () => {
                        message.success(
                          `Successfully deleted ${bData.BranchName}`,
                        );
                        this.updateBranchesTable();
                      },
                      usertoken,
                    );
                  }
                : null
            }
            onEdit={
              editPermission
                ? (branchData) => {
                    PopupManager.launchEditBranchPopup(branchData);
                  }
                : null
            }
            onDuplicate={(branchData) => {}}
          ></BranchTableView>
        </motion.div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    globalSearch: state.globalSearch,
    selectedBrandData: state.selectedBrandData,
  };
};

export default connect(mapStateToProps, {
  requestServerGet,
  requestServerPost,
  selectBrand,
  selectBranch,
  selectPage,
})(BranchPage);
